module.exports = __webpack_public_path__ + "static/media/Error Icon.eefa8ef6.svg";